import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import type { SteppedContainerComponentType } from '@unifyapps/defs/blocks/SteppedContainer/types';
import _pick from 'lodash/pick';
import { lazy } from 'react';
import type { DependsOnType } from '@unifyapps/defs/types/page';
import { ENTIRE_ENTITY } from '@unifyapps/carbon/no-code/dependency/const';

const importSteppedContainerComponent = () =>
  import(
    /* webpackChunkName: "stepped-container-block" */
    './SteppedContainer'
  );

const SteppedContainer = lazy(importSteppedContainerComponent);

class SteppedContainerBlockStateDefinition implements BlockStateDefinition {
  get type(): ComponentTypeUnionType {
    return 'SteppedContainer';
  }

  getImplicitDependencies = (
    block: BlockType<SteppedContainerComponentType>,
  ): DependsOnType[] | undefined => {
    const stepperId = block.component.content.stepperId;
    if (stepperId) {
      return [
        {
          id: stepperId,
          // todo: test this entire entity if it is working correctly
          p: [ENTIRE_ENTITY],
        },
      ];
    }
  };

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component as SteppedContainerComponentType, [
          'content',
          'componentType',
          'appearance',
        ]),
      }) as BlockStateUnionType;
  }

  getComponent() {
    return SteppedContainer;
  }

  preload() {
    return {
      blockPreload: importSteppedContainerComponent,
    };
  }
}

export default SteppedContainerBlockStateDefinition;
